import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CategoryStatusCssClasses } from "../CategoriesUIHelpers";
import * as actions from "../../../_redux/categories/categoriesActions";
import { useCategoriesUIContext } from "../CategoriesUIContext";

const selectedCategories = (entities, ids) => {
  const _categories = [];
  ids.forEach((id) => {
    const category = entities.find((el) => el.id === id);
    if (category) {
      _categories.push(category);
    }
  });
  return _categories;
};

export function CategoriesUpdateStatusDialog({ show, onHide }) {
  // Categories UI Context
  const categoriesUIContext = useCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      ids: categoriesUIContext.ids,
      setIds: categoriesUIContext.setIds,
      queryParams: categoriesUIContext.queryParams,
    };
  }, [categoriesUIContext]);

  // Categories Redux state
  const { categories, isLoading } = useSelector(
    (state) => ({
      categories: selectedCategories(state.categories.entities, categoriesUIProps.ids),
      isLoading: state.categories.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected categories we should close modal
  useEffect(() => {
    if (!categoriesUIProps.ids || categoriesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesUIProps.ids]);

  const [status, setStatus] = useState("active");

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updating category by ids
    dispatch(actions.updateCategoriesStatus(categoriesUIProps.ids, status)).then(
      () => {
        // refresh list after update
        dispatch(actions.fetchCategories(categoriesUIProps.queryParams)).then(
          () => {
            // clear selections list
            categoriesUIProps.setIds([]);
            // closing modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="category-status-modal-title"
    >
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="category-status-modal-title" className="font-weight-bolder text-dark">
          Update Status for Selected Categories
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="alert alert-custom alert-light-primary fade show mb-4 py-3 px-4 d-flex align-items-center" role="alert">
          <div className="alert-icon mr-3">
            <i className="fa fa-info-circle text-primary font-size-h5"></i>
          </div>
          <div className="alert-text font-size-sm text-dark font-weight-bold">
            Updating status for <span className="text-primary font-size-lg font-weight-bolder">{categoriesUIProps.ids.length}</span> selected categories.
          </div>
        </div>

        <div className="form-group mb-2">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Change Status To
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={updateStatus}
          className="btn btn-primary font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Updating...
            </>
          ) : (
            "Update Status"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
